import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0663118"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tpsDisplay"
}
const _hoisted_2 = {
  key: 0,
  class: "low"
}

import state from "game/state";
import Decimal, { DecimalSource, formatWhole } from "util/bignum";
import { computed, ref, watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tps = computed(() =>
    Decimal.div(
        state.lastTenTicks.length,
        state.lastTenTicks.reduce((acc, curr) => acc + curr, 0)
    )
);

const lastTenFPS = ref<number[]>([]);
watchEffect(() => {
    lastTenFPS.value.push(Math.round(tps.value.toNumber()));
    if (lastTenFPS.value.length > 10) {
        lastTenFPS.value = lastTenFPS.value.slice(1);
    }
});

const low = computed(() =>
    lastTenFPS.value.reduce<DecimalSource>((acc, curr) => Decimal.max(acc, curr), 0)
);

const showLow = computed(() => Decimal.sub(tps.value, low.value).gt(1));

return (_ctx: any,_cache: any) => {
  return (!_unref(tps).isNan())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(" TPS: " + _toDisplayString(_unref(formatWhole)(_unref(tps))) + " ", 1),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_unref(showLow))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(formatWhole)(_unref(low))), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})